import {
  productFamilyOptionIdFormat,
  productFamilyOptionValueIdFormat,
  productIdFormat,
} from "@redotech/redo-ids/ids";
import * as z from "zod";

const VariantOptionValue_ = z.object({
  id: productFamilyOptionValueIdFormat.schema,
  value: z.string(),
});
export const VariantOptionValue: z.ZodType<VariantOptionValue> =
  VariantOptionValue_;
export interface VariantOptionValue extends z.infer<
  typeof VariantOptionValue_
> {}

const VariantOption_ = z.object({
  id: productFamilyOptionIdFormat.schema,
  name: z.string(),
  values: z.array(VariantOptionValue),
});
export const VariantOption: z.ZodType<VariantOption> = VariantOption_;
export interface VariantOption extends z.infer<typeof VariantOption_> {}

export const getProductVariantOptions = {
  name: "getProductVariantOptions" as const,
  input: z.object({ productId: productIdFormat.schema }),
  output: z.object({ options: z.array(VariantOption) }),
};
